import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IUploadPathResponse } from '../ack-schema';
import { uploadPathResponseSchema } from '../ack-schema';

export async function uploadCreditPhotoApi(
  collectionId: number,
  creditId: number,
  file: File,
): Promise<IValidatedResponse<IUploadPathResponse>> {
  const body = new FormData();
  body.append('file', file);
  return postRequest<IUploadPathResponse>({
    path: `/sys/collections/${collectionId}/credits/${creditId}/upload-photo/v1`,
    body,
    schema: uploadPathResponseSchema,
  });
}
